import { Tag, Typography, Divider, Button } from "antd";
import { CloseOutlined, UserAddOutlined } from "@ant-design/icons";
import dayjs from "../../../utils/dayjs";
import { getFullName } from "../../../utils/shared";
import { useMemo, useState } from "react";
import RemoveMember from "./Member/RemoveMember";
import Avatar from "../../../components/generic/Avatar";
import AddMembers from "./Member/AddMembers";

const { Text } = Typography;

const TicketInfo = ({ selectedChat, setIsShowTicketInfo, user }) => {
  const {
    display_id,
    topic,
    branch,
    status,
    priority,
    created_at,
    assigned_advisor,
    customer_id,
    customers = [],
    name,
  } = selectedChat || {};
  const [showAddMemberModal, setShowAddMemberModal] = useState(false);

  const isCreatedCus = useMemo(
    () => customer_id === user?.user_id,
    [customer_id, user],
  );

  return (
    <div className="ticket-container h-100 slide-in-right">
      {/* Header */}
      <div className="flex  ticket-header align-center justify-space-between">
        <h2>Ticket Information</h2>
        <Button
          icon={<CloseOutlined />}
          onClick={() => setIsShowTicketInfo(false)}
          type="text"
        />
      </div>

      <div className="info-body">
        <div className="info-section">
          <div className="info-row">
            <Text type="secondary" className="info-label">
              Ticket Id:
            </Text>
            <Text className="info-value">#{display_id}</Text>
          </div>
          <div className="info-row">
            <Text type="secondary" className="info-label">
              Name:
            </Text>
            <Text className="info-value">{name || "Not Found"}</Text>
          </div>
          <div className="info-row">
            <Text type="secondary" className="info-label">
              Topic:
            </Text>
            <Text className="info-value">{topic?.name}</Text>
          </div>
          <div className="info-row">
            <Text type="secondary" className="info-label">
              Branch:
            </Text>
            <Text className="info-value">{branch?.name}</Text>
          </div>
          <div className="info-row">
            <Text type="secondary" className="info-label">
              Priority:
            </Text>
            <Tag
              color={
                priority === "high"
                  ? "red"
                  : priority === "normal"
                    ? "blue"
                    : "default"
              }
              className="priority-tag"
            >
              {priority?.toUpperCase()}
            </Tag>
          </div>
          <div className="info-row">
            <Text type="secondary" className="info-label">
              Status:
            </Text>
            <Text className="info-value capitalize-text">{status}</Text>
          </div>
          <div className="info-row">
            <Text type="secondary" className="info-label">
              Created:
            </Text>
            <Text className="info-value">
              {dayjs(created_at).format("DD MMM YYYY, hh:mm A")}
            </Text>
          </div>
        </div>

        <Divider className="ticket-divider" />

        <div className="info-section">
          <Text strong className="section-title">
            Assigned Advisor
          </Text>
          <div className="info-row">
            <Text type="secondary" className="info-label">
              Name:
            </Text>
            <Text className="info-value">{getFullName(assigned_advisor)}</Text>
          </div>
          <div className="info-row">
            <Text type="secondary" className="info-label">
              Phone:
            </Text>
            <Text className="info-value">
              {assigned_advisor?.mobile_number}
            </Text>
          </div>
        </div>

        <Divider className="ticket-divider" />

        <div className="info-section">
          <div className="flex justify-space-between header">
            <Text strong className="section-title">
              Members
            </Text>
            {isCreatedCus && (
              <Button
                icon={<UserAddOutlined />}
                shape="circle"
                type="primary"
                size="small"
                onClick={() => setShowAddMemberModal(true)}
              />
            )}
          </div>
          <div className="members-list">
            {customers?.map((member) => (
              <div key={member.id} className="member-item ">
                <Avatar user={member} size={38} />

                <div className="member-details">
                  <div className="member-name ellipsis-text">
                    {getFullName(member)}
                  </div>
                  <div className="member-email ellipsis-text">
                    {`${member.phone_country_code}-${member.phone}` ||
                      "Phone Number not Found"}{" "}
                    | {member.email || "Email not Found"}
                  </div>
                </div>
                {isCreatedCus && member?.id !== customer_id && (
                  <RemoveMember
                    user={member}
                    conversation_id={selectedChat?.id}
                  />
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
      {showAddMemberModal && (
        <AddMembers
          onCancel={() => setShowAddMemberModal(false)}
          selectedChat={selectedChat}
          customers={customers}
        />
      )}
    </div>
  );
};

export default TicketInfo;
